<template>
    <v-card>
        <v-card-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="create" v-if="userIsFleetManager">Create Campaign</v-btn>
        </v-card-title>
        <v-data-table
            :items="campaigns"
            :headers="headers"
            :loading="$wait.is(['loading campaigns'])"
        >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:item="props">
                <tr
                    @click="show(props.item)"
                    :class="{completed:props.item.remaining == 0, 'past-due': props.item.pastDue != 0}"
                >
                    <td>{{props.item.campaignNumber}}</td>
                    <td>{{props.item.tsbWpaReference}}</td>
                    <td>{{props.item.name}}</td>
                    <td>{{moment(props.item.createdOn) | formatDate}}</td>
                    <td>
                        {{moment(props.item.maxCompletionDate) | formatDate}}
                        <v-chip
                            v-if="props.item.pastDue"
                            class="ml-2"
                            label
                            small
                            color="red"
                            :dark="true"
                        >+{{props.item.overdueDays}}</v-chip>
                    </td>
                    <td>{{props.item.count}}</td>
                    <td>{{props.item.remaining}}</td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-layout row align-center>
                    <v-flex>No matching records found</v-flex>
                </v-layout>
            </template>
        </v-data-table>
        <campaign ref="campaign"></campaign>
    </v-card>
</template>
<script>
import CampaignClient from './CampaignClient.vue';
import Campaign from './Campaign.vue';
import { DateFormat } from '../../plugins/date-filter';
import moment from 'moment';
import { Event, EventBus } from '@/plugins/bus';

export default {
    mixins: [CampaignClient],
    components: { Campaign },
    data() {
        return {
            campaigns: [],
            loading: true,
            headers: [
                { text: 'Number', value: 'campaignNumber' },
                { text: 'TSB / Reference', value: 'tsbWpaReference' },
                { text: 'Name', value: 'name' },
                { text: 'Created', value: 'createdOn' },
                { text: 'Due By', value: 'maxCompletionDate' },
                { text: 'Units', value: 'count' },
                { text: 'Remaining', value: 'remaining' }
            ]
        };
    },
    methods: {
        show(campaign) {
            this.$refs.campaign.show(campaign);
        },
        create() {
            this.$refs.campaign.create();
        },
        async load() {
            this.campaigns = await this.getCampaigns();
        }
    },
    async created() {
        await this.load();
        EventBus.$on(Event.CampaignUpdated, this.load);
        EventBus.$on(Event.CampaignUnitMoved, this.load);
    },
    destroyed() {
        EventBus.$off(Event.CampaignUpdated, this.load);
        EventBus.$off(Event.CampaignUnitMoved, this.load);
    }
};
</script>
